import React, { useEffect, useState } from 'react';
import useSWR from 'swr';
import { Link, useHistory } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import Loading from '../components/loading';

import { apiFetch } from '../lib/fetch';
import useUser from '../lib/useUser';
import Layout from '../components/layout';
import IPHouseholdSearch from '../components/ip-household-search';
import { colors } from '../lib/styles';
import { Button } from '../lib/common';

const styles = {
  card: {
    cursor: 'pointer',
    display: 'flex',
    margin: '20px',
  },
  btn: {
    marginBottom: '20px',
  },
  search: {
    marginBottom: '24px',
    marginTop: '24px',
    fontSize: 18,
    borderRadius: '4px',
    width: '100%',
    height: '50px',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'center',
  },
  signDiv: {
    display: 'flex',
    margin: '25px',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  signMsg: {
    fontSize: '1.5em',
    margin: '10px',
  },
  pendingApproval: {
    width: '100%',
    color: 'white',
    margin: '20px',
    padding: '10px',
  },
  pendingApprovalText: {
    width: '100%',
    backgroundColor: 'green',
    color: 'white',
    borderRadius: '5px',
    fontSize: '2em',
    margin: '20px',
    padding: '10px',
    textAlign: 'center',
  },
  agentApprovalItem: {
    marginLeft: '20px',
    fontSize: '0.9em',
    display: 'flex',
  },
  gridContainer: {
    width: '100%',
    display: 'flex',
    height: 450,
  },
};

const columns = [
  { field: 'id', hide: true },
  {
    field: 'household_name',
    headerName: 'Household',
    align: 'left',
    width: 150,
  },
  {
    field: 'firstname',
    headerName: 'First Name',
    align: 'left',
    width: 150,
  },
  {
    field: 'lastname',
    headerName: 'Last Name',
    align: 'left',
    width: 150,
  },
  {
    field: 'age',
    headerName: 'Age',
    align: 'left',
    width: 60,
    renderCell: (params) => {
      return params.row.dob ? moment().diff(params.row.dob, 'years', false) : '';
    },
  },
  {
    field: 'dob',
    headerName: 'DOB',
    align: 'left',
    width: 120,
    renderCell: (params) => {
      return params.row.dob ? moment(params.row.dob).format('YYYY-MM-DD') : '';
    },
  },
  {
    field: 'details',
    headerName: 'Planning',
    align: 'left',
    width: 80,
    renderCell: (params) => {
      const url = `/clients/${params.row.id}`;
      return <Link style={{ color: colors.black }} to={url}>Details</Link>;
    },
  },
];

export default function AgentDashboard() {
  const authUser = useUser();
  const [user, setUser] = useState(null);
  const userId = useUser()?.id;
  const history = useHistory();

  // const url = `/users/${userId}/clients/all?is_deleted=false&orderBy=created_at&limit=5000`;
  const url = `/users/${userId}/ip_households?orderBy=created_at&limit=5000`;

  const { data: bsf, loading: bsfLoading } = useSWR(url);

  useEffect(() => {
    async function fetchUser() {
      setUser(await apiFetch(`/users/${authUser.id}/stats`));
    }
    fetchUser();
  }, [authUser]);

  if (!user) return <Loading />;

  return (
    <Layout>
      <div
        style={{
          margin: '15px',
        }}
      >
        <div style={{ width: '400px', marginBottom: '15px' }}>
          <IPHouseholdSearch
            style={styles.search}
            onChange={(c) => {
              // console.log(c);
              history.push(`/clients/${c.id}`);
            }}
          />
        </div>
        <div>
          <Button
            style={styles.btn}
            onClick={() => {
              history.push('/clients/new');
            }}
            sx={{ backgroundColor: colors.black, color: colors.white }}
          >
            Add Client
          </Button>
        </div>
        <div>
          <Paper>
            {!bsfLoading ? (
              <div style={styles.gridContainer}>
                <DataGrid columns={columns} rows={bsf || []} />
              </div>
            ) : <CircularProgress/>}
          </Paper>
        </div>
      </div>
    </Layout>
  );
}
